import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import './plugins/vuetify';
import './plugins/vuelidate';
import './plugins/google_maps';
import './plugins/v_currency';
import './plugins/vue-observe-visibility';
import './plugins/vue-cookies';
import './plugins/vue-beautiful-chat';
import vuetify from './plugins/vuetify';


Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount("#app");

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = process.env.VUE_APP_TITLE + " - " + to.meta.title;
  } else {
    document.title = process.env.VUE_APP_TITLE;
  }
  next();
});